import { useState } from 'react';
import { Form } from 'antd';
import { useLimpiarCache, useRectificacion, useCustomComando } from '../queries';

export const useComandos = () => {
  const [form] = Form.useForm();
  const [selectedRectificacion, setSelectedRectificacion] = useState(null);
  const [modalRectificarVisible, setModalRectificarVisible] = useState(false);
  const [argumento, setArgumento] = useState('');

  // Hooks de las APIs
  const limpiarCache = useLimpiarCache();
  const rectificar = useRectificacion();
  const customComando = useCustomComando();

  // Handlers
  const onFinishComandoPersonalizado = (values) => {
    customComando.mutateAsync(values);
  };

  const handleRectificarClick = () => {
    setModalRectificarVisible(true);
  };
  const handleRectificarSubmit = () => {
    if (selectedRectificacion) {
      const payload = { tipo: selectedRectificacion };
      if (argumento.trim()) {
        payload.argumento = argumento.trim();
      }
      rectificar.mutate(payload);
      setModalRectificarVisible(false);
      setSelectedRectificacion(null);
      setArgumento('');
    }
  };

  const handleModalCancel = () => {
    setModalRectificarVisible(false);
    setSelectedRectificacion(null);
    setArgumento('');
  };

  const handleSelectionChange = (value) => {
    setSelectedRectificacion(value);
  };

  const handleArgumentoChange = (value) => {
    setArgumento(value);
  };
  return {
    // Form
    form,
    
    // Estado del modal
    selectedRectificacion,
    modalRectificarVisible,
    argumento,
    
    // APIs
    limpiarCache,
    rectificar,
    customComando,
    
    // Handlers
    onFinishComandoPersonalizado,
    handleRectificarClick,
    handleRectificarSubmit,
    handleModalCancel,
    handleSelectionChange,
    handleArgumentoChange
  };
};
